import { makeStyles } from "@material-ui/core/styles";

const styles = {
	root: {
		backgroundColor: "#d84c93",
		color: "white",
		fontWeight: "600",
		margin: "1em",
		"&:hover": {
			backgroundColor: "#ad095b",
		},
		"&:active": {
			backgroundColor: "#ad095b",
		},
	},
};

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		padding: "1em",
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		maxWidth: "500px",
		margin: "auto",
		color: theme.palette.text.secondary,
	},
	grid: {
		padding: theme.spacing(2),
	},
	formControl: {
		margin: theme.spacing(1),
	},
	formGroup: {
		display: "flex",
		flexDirection: "row",
	},
	inputFile: {
		display: "none",
	},
	returnButton: {
		backgroundColor: "#999999",
		color: "white",
		fontWeight: "600",
		margin: "1em",
		"&:hover": {
			backgroundColor: "#BEBEBE",
		},
		"&:active": {
			backgroundColor: "#ad095b",
		},
	},
}));

export { styles, useStyles };
